/* import __COLOCATED_TEMPLATE__ from './confirm-square-one-pricing-modal.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { SquareOnePricingDeviceType } from './confirm-square-one-pricing';
let ConfirmSquareOnePricingModal = (_class = class ConfirmSquareOnePricingModal extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "formatter", _descriptor2, this);
  }
  get device() {
    return this.args.deviceType === SquareOnePricingDeviceType.KIOSK ? this.args.pricingInfo.units.kiosk : this.args.pricingInfo.units.device;
  }
  get isRemoving() {
    const newCost = this.device.add(this.args.pricingInfo.currentCost);
    // see if we are adding or subtracting
    return this.args.pricingInfo.currentCost.amount > newCost.amount;
  }
  get modalCopy() {
    return this.isRemoving ? {
      header: this.intl.t('sharedUi.confirmSquareOnePricing.remove.header'),
      description: this.intl.t('sharedUi.confirmSquareOnePricing.remove.description', {
        unitPrice: this.formatter.formatMoney(this.device.cost)
      })
    } : {
      header: this.intl.t('sharedUi.confirmSquareOnePricing.add.header'),
      description: this.intl.t('sharedUi.confirmSquareOnePricing.add.description', {
        unitPrice: this.formatter.formatMoney(this.device.cost)
      })
    };
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ConfirmSquareOnePricingModal as default };